import { HostBinding, Component, ChangeDetectionStrategy } from '@angular/core';
import { CardComponent } from '../card.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FavoriteListComponent } from '../../favorite-list/favorite-list.component';

@Component({
  selector: 'app-sub-card',
  templateUrl: './sub-card.component.html',
  styleUrls: ['./sub-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbTooltip, FavoriteListComponent],
})
export class SubCardComponent extends CardComponent {
  @HostBinding('class.card') card = false;

  @HostBinding('class.sub-card') subCard = true;
}
